import json from './sprite.js';

export default {
    handle: 'en_SPT10-Candy',
    label: 'en_SPT10-Candy',
    json,
};
